var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClosedModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4071 10.0071C15.7976 9.61658 15.7976 8.98342 15.4071 8.59289C15.0166 8.20237 14.3834 8.20237 13.9929 8.59289L15.4071 10.0071ZM8.59289 13.9929C8.20237 14.3834 8.20237 15.0166 8.59289 15.4071C8.98342 15.7976 9.61658 15.7976 10.0071 15.4071L8.59289 13.9929ZM10.0071 8.59289C9.61658 8.20237 8.98342 8.20237 8.59289 8.59289C8.20237 8.98342 8.20237 9.61658 8.59289 10.0071L10.0071 8.59289ZM13.9929 15.4071C14.3834 15.7976 15.0166 15.7976 15.4071 15.4071C15.7976 15.0166 15.7976 14.3834 15.4071 13.9929L13.9929 15.4071ZM20 12C20 16.4183 16.4183 20 12 20V22C17.5228 22 22 17.5228 22 12H20ZM12 20C7.58172 20 4 16.4183 4 12H2C2 17.5228 6.47715 22 12 22V20ZM4 12C4 7.58172 7.58172 4 12 4V2C6.47715 2 2 6.47715 2 12H4ZM12 4C16.4183 4 20 7.58172 20 12H22C22 6.47715 17.5228 2 12 2V4ZM13.9929 8.59289L8.59289 13.9929L10.0071 15.4071L15.4071 10.0071L13.9929 8.59289ZM8.59289 10.0071L13.9929 15.4071L15.4071 13.9929L10.0071 8.59289L8.59289 10.0071Z",
    fill: "#0E0F11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClosedModal);
export default __webpack_public_path__ + "static/media/iconClosedModal.22362ed8454e7a28a8457a7e5a90f0b1.svg";
export { ForwardRef as ReactComponent };